import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { CLOUDIA_SERVICES } from '@cloudia-internal/src/app/core/interceptors/claudia-services';
import { environment } from '@envs/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class GlobalHttpInterceptor implements HttpInterceptor {
  constructor(private readonly toastrService: ToastrService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const secureReq = req.clone({
      url: this.getRemoteUrlForBackend(req.url),
    });

    return next.handle(secureReq).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            if (!location.href.includes('csat/evaluation')) {
              this.toastrService
                .warning('Tap to login again', 'Session expired')
                .onTap.subscribe((value) => {
                  location.reload();
                });
            }
          }
        }
      )
    );
  }

  private getRemoteUrlForBackend(originUrl: string): string {
    const baseUrl = environment.apiUrl.replace('/api/', '');
    let targetUrl = '';

    Object.entries(CLOUDIA_SERVICES).forEach(([name, body]) => {
      const found = body.endpoints.find(
        (endpointName) =>
          originUrl.includes(`/api${endpointName}`) &&
          !originUrl.includes(body.basePath)
      );

      if (found) {
        targetUrl = originUrl.includes(baseUrl)
          ? originUrl.replace(
              baseUrl + '/api/',
              baseUrl + `/${body.basePath}/api/`
            )
          : originUrl.replace('/api/', `/${body.basePath}/api/`);
      }
    });

    return targetUrl;
  }
}
